import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Spinner } from 'reactstrap';

const buttonClass = 'tbx-button'
const Button = ({
  text,
  onClick,
  hierarchy = 'solid',
  textAlign,
  active,
  isNeutral,
  isSubmitting,
  isVerify,
  disabled
}) => {
  const mainClass = classNames(buttonClass, `${buttonClass}--${hierarchy}`, {
    [`${buttonClass}--${textAlign}`]: textAlign,
    [`${buttonClass}--active`]: active,
    [`${buttonClass}--neutro`]: isNeutral,
    [`${buttonClass}--verify`]: isVerify,
    [`${buttonClass}--disabled`]: disabled
  })
  const textClass = classNames(`${buttonClass}__text`, {
    [`${buttonClass}__text--${textAlign}`]: textAlign
  })
  return (
    <button
      type="button"
      aria-label={text}
      className={mainClass}
      onClick={onClick}
      disabled={disabled}
    >
      {
        isSubmitting
          ? <Spinner className={`${buttonClass}__spinner`} />
          : <span className={textClass}>{text}</span>
      }
    </button>
  )
}

Button.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  onClick: PropTypes.func.isRequired,
  hierarchy: PropTypes.oneOf(['solid', 'quiet', 'transparent']),
  textAlign: PropTypes.oneOf(['left', 'center']),
  active: PropTypes.bool,
  isNeutral: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  isVerify: PropTypes.bool,
  disabled: PropTypes.bool,
}

Button.defaultPropTypes = {
  hierarchy: 'solid',
  textAlign: 'center',
  isNeutral: false,
  disabled: false
}

export default Button;
